import * as React from "react";
import type { SVGProps } from "react";
const SvgUnifiedExperience = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M9.934 50.787a5.227 5.227 0 1 0 0-10.455 5.227 5.227 0 0 0 0 10.455Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M9.935 41.184a4.376 4.376 0 1 0 0 8.751 4.376 4.376 0 0 0 0-8.75ZM3.856 45.56a6.079 6.079 0 1 1 12.158 0 6.079 6.079 0 0 1-12.158 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M17.468 63.062h-15c-.779 0-1.48-.526-1.567-1.305-.682-6.103 5.743-7.738 9.267-7.777 7.592.448 9.062 4.818 8.809 7.806-.068.76-.75 1.266-1.518 1.266l.01.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M10.158 53.128c.02 0 .04 0 .06.002 3.955.233 6.47 1.501 7.947 3.251 1.469 1.74 1.8 3.824 1.66 5.477v.005c-.11 1.224-1.14 1.962-2.193 2.035a.85.85 0 0 1-.164.016h-15c-1.133 0-2.27-.778-2.414-2.061v-.001c-.188-1.686.112-3.112.767-4.292.65-1.173 1.621-2.05 2.698-2.696 2.134-1.28 4.785-1.715 6.64-1.736Zm7.172 9.082a.856.856 0 0 1 .129-.01c.426 0 .648-.26.67-.488.112-1.334-.164-2.928-1.265-4.232-1.09-1.29-3.098-2.429-6.716-2.648-1.668.023-3.974.426-5.752 1.493-.885.53-1.613 1.209-2.085 2.061-.469.844-.716 1.91-.564 3.277l-.846.095.846-.096c.031.274.297.548.721.548H17.33Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32.002 50.787a5.227 5.227 0 1 0 0-10.455 5.227 5.227 0 0 0 0 10.455Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.002 41.184a4.376 4.376 0 1 0 0 8.751 4.376 4.376 0 0 0 0-8.75Zm-6.08 4.376a6.079 6.079 0 1 1 12.159 0 6.079 6.079 0 0 1-12.158 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M39.536 63.062h-15c-.779 0-1.48-.526-1.567-1.305-.682-6.103 5.743-7.738 9.267-7.777 7.592.448 9.062 4.818 8.809 7.806-.068.76-.75 1.266-1.519 1.266l.01.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.225 53.128c.02 0 .04 0 .06.002 3.955.233 6.47 1.501 7.947 3.251 1.468 1.74 1.8 3.824 1.66 5.477v.005c-.11 1.224-1.14 1.962-2.193 2.035a.85.85 0 0 1-.164.016h-15c-1.133 0-2.27-.778-2.414-2.061v-.001c-.188-1.686.112-3.112.767-4.292.65-1.173 1.621-2.05 2.698-2.696 2.134-1.28 4.785-1.715 6.64-1.736Zm7.172 9.082a.856.856 0 0 1 .129-.01c.426 0 .648-.26.67-.488.112-1.334-.164-2.928-1.265-4.232-1.09-1.29-3.098-2.429-6.716-2.648-1.668.023-3.974.426-5.753 1.493-.884.53-1.612 1.209-2.084 2.061-.469.844-.716 1.91-.564 3.277l-.846.095.846-.096c.031.274.297.548.721.548h14.862Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M54.079 50.787a5.227 5.227 0 1 0 0-10.455 5.227 5.227 0 0 0 0 10.455Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M54.078 41.184a4.376 4.376 0 1 0 0 8.751 4.376 4.376 0 0 0 0-8.75ZM48 45.56a6.079 6.079 0 1 1 12.158 0 6.079 6.079 0 0 1-12.157 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M61.614 63.062h-15c-.78 0-1.48-.526-1.568-1.305-.681-6.103 5.743-7.738 9.267-7.777 7.593.448 9.063 4.818 8.81 7.806-.069.76-.75 1.266-1.519 1.266l.01.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M54.303 53.128c.02 0 .04 0 .06.002 3.955.233 6.47 1.501 7.947 3.251 1.468 1.74 1.8 3.824 1.66 5.477v.005c-.11 1.224-1.14 1.962-2.194 2.035a.852.852 0 0 1-.163.016h-15c-1.134 0-2.27-.778-2.414-2.061v-.001c-.188-1.686.112-3.112.767-4.292.65-1.173 1.62-2.05 2.698-2.696 2.133-1.28 4.785-1.715 6.639-1.736Zm7.172 9.082a.857.857 0 0 1 .128-.01c.427 0 .649-.26.67-.488.113-1.334-.164-2.928-1.265-4.232-1.09-1.29-3.098-2.429-6.716-2.648-1.667.023-3.973.426-5.752 1.493-.884.53-1.612 1.209-2.085 2.061-.468.844-.716 1.91-.563 3.277l-.847.095.847-.096c.03.274.296.548.72.548h14.862ZM19.332.939c0-.47.382-.852.852-.852h23.644c.47 0 .852.381.852.852v7.417c0 .47-.381.852-.852.852H20.184a.852.852 0 0 1-.852-.852V.939Zm1.704.851v5.714h21.94V1.79h-21.94Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.002 7.758c.47 0 .851.38.851.851v28.453a.852.852 0 0 1-1.703 0V8.61c0-.47.381-.851.852-.851ZM8.878 4.19c0-.47.382-.852.852-.852h10.192a.852.852 0 0 1 0 1.704h-9.34v31.563a.852.852 0 1 1-1.704 0V4.19ZM43.133 4.19c0-.47.381-.852.851-.852h9.783c.47 0 .852.381.852.852v32.415a.852.852 0 0 1-1.703 0V5.042h-8.931a.852.852 0 0 1-.852-.852Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M9.837 22.09a3.913 3.913 0 1 0 0-7.825 3.913 3.913 0 0 0 0 7.826Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M9.837 15.116a3.061 3.061 0 1 0 0 6.123 3.061 3.061 0 0 0 0-6.123Zm-4.765 3.062a4.765 4.765 0 1 1 9.53 0 4.765 4.765 0 0 1-9.53 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M53.942 22.09a3.913 3.913 0 1 0 0-7.825 3.913 3.913 0 0 0 0 7.826Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M53.942 15.116a3.061 3.061 0 1 0 0 6.123 3.061 3.061 0 0 0 0-6.123Zm-4.765 3.062a4.765 4.765 0 1 1 9.53 0 4.765 4.765 0 0 1-9.53 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32.022 29.966a3.913 3.913 0 1 0 0-7.826 3.913 3.913 0 0 0 0 7.826Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.02 22.991a3.061 3.061 0 1 0 0 6.123 3.061 3.061 0 0 0 0-6.123Zm-4.764 3.062a4.765 4.765 0 1 1 9.53 0 4.765 4.765 0 0 1-9.53 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUnifiedExperience;
